import { render, staticRenderFns } from "./ReactivacionServicio.vue?vue&type=template&id=6124a85e&"
import script from "./ReactivacionServicio.vue?vue&type=script&lang=js&"
export * from "./ReactivacionServicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports